var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"interdental-space",class:[_vm.selectedClass]},[_c('circle',{attrs:{"cx":_vm.x,"cy":_vm.y,"r":"10","fill":_vm.fillColor},on:{"click":_vm.onClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }